import React from 'react';
import { ErrorBoundary as ErrorBoundaryComponent } from '@cashfree-intl/coherent';
import * as Sentry from '@sentry/react';

const ErrorBoundary = ({ children, fallback }) => {
  const handleError = ({ errMsg, ...tags }) => {
    Sentry.captureException(errMsg, {
      tags,
    });
  };

  return (
    <ErrorBoundaryComponent onError={handleError} fallback={fallback}>
      {children}
    </ErrorBoundaryComponent>
  );
};

export default ErrorBoundary;
